export const StorageService = {
  getItem: (key) => localStorage.getItem(key) || window.electron?.store.get(key),
  setItem: (key, value) => {
    localStorage.setItem(key, value);
    if (window.electron) {
      window.electron.store.set(key, value);
    }
  }
};